let checkPath;

let stagingURL = (window.location.hostname === "staging.franchise.care");
let localhostURL = (window.location.hostname === "localhost");



export default checkPath = (stagingURL || localhostURL)